/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { SELECTED_SHIPPING_METHOD_FRAGMENT } from './ShippingMethodFragment';

export const NEGOTIABLE_QUOTE_SHIPPING_ADDRESS_FRAGMENT = /* GraphQL */ `
  fragment NEGOTIABLE_QUOTE_SHIPPING_ADDRESS_FRAGMENT on NegotiableQuoteShippingAddress {
    uid
    firstname
    lastname
    company
    street
    city
    region {
      code
      label
      region_id
    }
    postcode
    country {
      code
      label
    }
    telephone

    selected_shipping_method {
      ...SELECTED_SHIPPING_METHOD_FRAGMENT
    }
  }

  ${SELECTED_SHIPPING_METHOD_FRAGMENT}
`;
